// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ObjectNoResponse,
    ProviderNynf3Claim,
    ProviderNynf3ClaimTemplate,
    ProviderNynf3SortType,
    SupportCreateNynf3ClaimPayload,
    SupportCreateNynf3ClaimTemplatePayload,
    SupportNynf3Claim,
    SupportNynf3ClaimTemplate,
    SupportNynf3SortType,
    SupportNynf3TemplateSortType,
    SupportUpdateNynf3ClaimPayload,
    SupportUpdateNynf3ClaimTemplatePayload,
    SupportCreateNynf3ClaimPayloadToJSON,
    SupportCreateNynf3ClaimTemplatePayloadToJSON,
    SupportUpdateNynf3ClaimPayloadToJSON,
    SupportUpdateNynf3ClaimTemplatePayloadToJSON,
    ObjectNoResponseFromJSON,
    ProviderNynf3ClaimFromJSON,
    ProviderNynf3ClaimTemplateFromJSON,
    SupportNynf3ClaimFromJSON,
    SupportNynf3ClaimTemplateFromJSON,
} from '../models';

export interface CreateSupportNynf3ClaimRequest {
    supportCreateNynf3ClaimPayload: SupportCreateNynf3ClaimPayload;
}

export interface CreateSupportNynf3ClaimTemplateRequest {
    supportCreateNynf3ClaimTemplatePayload: SupportCreateNynf3ClaimTemplatePayload;
}

export interface DisableSupportNynf3ClaimRequest {
    id: string;
}

export interface GetProviderNynf3ClaimRequest {
    id: string;
}

export interface GetProviderNynf3ClaimTemplateRequest {
    id: string;
}

export interface GetSupportNynf3ClaimRequest {
    id: string;
}

export interface GetSupportNynf3ClaimTemplateRequest {
    id: string;
}

export interface ListProviderNynf3ClaimsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderNynf3ClaimsOrderEnum>;
    filterCreated?: Array<string>;
    filterPayerId?: Array<string>;
    filterSubscriberId?: Array<string>;
    filterPatientId?: Array<string>;
    filterFacilityId?: Array<string>;
    filterProviderId?: Array<string>;
    filterSellerId?: Array<string>;
    filterPaymentId?: Array<string>;
    filterClaimId?: Array<string>;
    filterFirst?: Array<string>;
    filterLast?: Array<string>;
    filterFirstLast?: Array<string>;
    filterDiagnosis?: Array<string>;
    filterPriorAuthorizationNumber?: Array<string>;
    filterCharge?: Array<string>;
    filterFromDos?: Array<string>;
    filterThroughDos?: Array<string>;
    filterProcedure?: Array<string>;
    filterModifier?: Array<string>;
    filterServiceCharge?: Array<string>;
    sort?: Array<ProviderNynf3SortType>;
}

export interface ListSupportNynf3ClaimTemplatesRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportNynf3ClaimTemplatesOrderEnum>;
    filterStarred?: string;
    filterCreated?: Array<string>;
    filterActive?: string;
    filterTag?: Array<string>;
    filterName?: Array<string>;
    sort?: Array<SupportNynf3TemplateSortType>;
}

export interface ListSupportNynf3ClaimsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportNynf3ClaimsOrderEnum>;
    filterStarred?: string;
    filterCreated?: Array<string>;
    filterActive?: string;
    filterTag?: Array<string>;
    filterPayerId?: Array<string>;
    filterSubscriberId?: Array<string>;
    filterPatientId?: Array<string>;
    filterFacilityId?: Array<string>;
    filterProviderId?: Array<string>;
    filterSellerId?: Array<string>;
    filterPaymentId?: Array<string>;
    filterClaimId?: Array<string>;
    filterFirst?: Array<string>;
    filterLast?: Array<string>;
    filterFirstLast?: Array<string>;
    filterDiagnosis?: Array<string>;
    filterPriorAuthorizationNumber?: Array<string>;
    filterCharge?: Array<string>;
    filterFromDos?: Array<string>;
    filterThroughDos?: Array<string>;
    filterProcedure?: Array<string>;
    filterModifier?: Array<string>;
    filterServiceCharge?: Array<string>;
    sort?: Array<SupportNynf3SortType>;
}

export interface UpdateSupportNynf3ClaimTemplateRequest {
    id: string;
    supportUpdateNynf3ClaimTemplatePayload: SupportUpdateNynf3ClaimTemplatePayload;
}

export interface UpdateSupportNynf3lClaimRequest {
    id: string;
    supportUpdateNynf3ClaimPayload: SupportUpdateNynf3ClaimPayload;
}

/**
 * no description
 */
export class Nynf3Api extends runtime.BaseAPI {

    /**
     * Create a NY NF3 claim
     * Create a NY NF3 claim
     */
    async createSupportNynf3ClaimRaw(requestParameters: CreateSupportNynf3ClaimRequest): Promise<runtime.ApiResponse<SupportNynf3Claim>> {
        if (requestParameters['supportCreateNynf3ClaimPayload'] === null || requestParameters['supportCreateNynf3ClaimPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateNynf3ClaimPayload','Required parameter requestParameters.supportCreateNynf3ClaimPayload was null or undefined when calling createSupportNynf3Claim.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:nynf3", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/nynf3`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateNynf3ClaimPayloadToJSON(requestParameters['supportCreateNynf3ClaimPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportNynf3ClaimFromJSON(jsonValue));
    }

    /**
     * Create a NY NF3 claim
     * Create a NY NF3 claim
     */
    async createSupportNynf3Claim(requestParameters: CreateSupportNynf3ClaimRequest): Promise<SupportNynf3Claim> {
        const response = await this.createSupportNynf3ClaimRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a nynf3 claim template
     * Create a nynf3 claim template
     */
    async createSupportNynf3ClaimTemplateRaw(requestParameters: CreateSupportNynf3ClaimTemplateRequest): Promise<runtime.ApiResponse<SupportNynf3ClaimTemplate>> {
        if (requestParameters['supportCreateNynf3ClaimTemplatePayload'] === null || requestParameters['supportCreateNynf3ClaimTemplatePayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateNynf3ClaimTemplatePayload','Required parameter requestParameters.supportCreateNynf3ClaimTemplatePayload was null or undefined when calling createSupportNynf3ClaimTemplate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:nynf3", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/nynf3/template`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateNynf3ClaimTemplatePayloadToJSON(requestParameters['supportCreateNynf3ClaimTemplatePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportNynf3ClaimTemplateFromJSON(jsonValue));
    }

    /**
     * Create a nynf3 claim template
     * Create a nynf3 claim template
     */
    async createSupportNynf3ClaimTemplate(requestParameters: CreateSupportNynf3ClaimTemplateRequest): Promise<SupportNynf3ClaimTemplate> {
        const response = await this.createSupportNynf3ClaimTemplateRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable a NY NF3 claim
     * Disable a NY NF3 claim
     */
    async disableSupportNynf3ClaimRaw(requestParameters: DisableSupportNynf3ClaimRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportNynf3Claim.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:nynf3", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/nynf3/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable a NY NF3 claim
     * Disable a NY NF3 claim
     */
    async disableSupportNynf3Claim(requestParameters: DisableSupportNynf3ClaimRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportNynf3ClaimRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a NY NF3 claim
     * Get an NY NF3 claim
     */
    async getProviderNynf3ClaimRaw(requestParameters: GetProviderNynf3ClaimRequest): Promise<runtime.ApiResponse<ProviderNynf3Claim>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderNynf3Claim.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:nynf3"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/nynf3/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderNynf3ClaimFromJSON(jsonValue));
    }

    /**
     * Gets a NY NF3 claim
     * Get an NY NF3 claim
     */
    async getProviderNynf3Claim(requestParameters: GetProviderNynf3ClaimRequest): Promise<ProviderNynf3Claim> {
        const response = await this.getProviderNynf3ClaimRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a nynf3 claim template
     * Get a nynf3 claim template
     */
    async getProviderNynf3ClaimTemplateRaw(requestParameters: GetProviderNynf3ClaimTemplateRequest): Promise<runtime.ApiResponse<ProviderNynf3ClaimTemplate>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderNynf3ClaimTemplate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:nynf3"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/nynf3/template/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderNynf3ClaimTemplateFromJSON(jsonValue));
    }

    /**
     * Gets a nynf3 claim template
     * Get a nynf3 claim template
     */
    async getProviderNynf3ClaimTemplate(requestParameters: GetProviderNynf3ClaimTemplateRequest): Promise<ProviderNynf3ClaimTemplate> {
        const response = await this.getProviderNynf3ClaimTemplateRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a NY NF3 claim
     * Get an NY NF3 claim
     */
    async getSupportNynf3ClaimRaw(requestParameters: GetSupportNynf3ClaimRequest): Promise<runtime.ApiResponse<SupportNynf3Claim>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportNynf3Claim.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:nynf3", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/nynf3/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportNynf3ClaimFromJSON(jsonValue));
    }

    /**
     * Gets a NY NF3 claim
     * Get an NY NF3 claim
     */
    async getSupportNynf3Claim(requestParameters: GetSupportNynf3ClaimRequest): Promise<SupportNynf3Claim> {
        const response = await this.getSupportNynf3ClaimRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a nynf3 claim template
     * Get a nynf3 claim template
     */
    async getSupportNynf3ClaimTemplateRaw(requestParameters: GetSupportNynf3ClaimTemplateRequest): Promise<runtime.ApiResponse<SupportNynf3ClaimTemplate>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportNynf3ClaimTemplate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:nynf3", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/nynf3/template/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportNynf3ClaimTemplateFromJSON(jsonValue));
    }

    /**
     * Gets a nynf3 claim template
     * Get a nynf3 claim template
     */
    async getSupportNynf3ClaimTemplate(requestParameters: GetSupportNynf3ClaimTemplateRequest): Promise<SupportNynf3ClaimTemplate> {
        const response = await this.getSupportNynf3ClaimTemplateRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of NY NF3 claims
     * Get a list of NY NF3 claims
     */
    async listProviderNynf3ClaimsRaw(requestParameters: ListProviderNynf3ClaimsRequest): Promise<runtime.ApiResponse<Array<ProviderNynf3Claim>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterPayerId) {
            queryParameters['filterPayerId'] = requestParameters.filterPayerId;
        }

        if (requestParameters.filterSubscriberId) {
            queryParameters['filterSubscriberId'] = requestParameters.filterSubscriberId;
        }

        if (requestParameters.filterPatientId) {
            queryParameters['filterPatientId'] = requestParameters.filterPatientId;
        }

        if (requestParameters.filterFacilityId) {
            queryParameters['filterFacilityId'] = requestParameters.filterFacilityId;
        }

        if (requestParameters.filterProviderId) {
            queryParameters['filterProviderId'] = requestParameters.filterProviderId;
        }

        if (requestParameters.filterSellerId) {
            queryParameters['filterSellerId'] = requestParameters.filterSellerId;
        }

        if (requestParameters.filterPaymentId) {
            queryParameters['filterPaymentId'] = requestParameters.filterPaymentId;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterFirst) {
            queryParameters['filterFirst'] = requestParameters.filterFirst;
        }

        if (requestParameters.filterLast) {
            queryParameters['filterLast'] = requestParameters.filterLast;
        }

        if (requestParameters.filterFirstLast) {
            queryParameters['filterFirstLast'] = requestParameters.filterFirstLast;
        }

        if (requestParameters.filterDiagnosis) {
            queryParameters['filterDiagnosis'] = requestParameters.filterDiagnosis;
        }

        if (requestParameters.filterPriorAuthorizationNumber) {
            queryParameters['filterPriorAuthorizationNumber'] = requestParameters.filterPriorAuthorizationNumber;
        }

        if (requestParameters.filterCharge) {
            queryParameters['filterCharge'] = requestParameters.filterCharge;
        }

        if (requestParameters.filterFromDos) {
            queryParameters['filterFromDos'] = requestParameters.filterFromDos;
        }

        if (requestParameters.filterThroughDos) {
            queryParameters['filterThroughDos'] = requestParameters.filterThroughDos;
        }

        if (requestParameters.filterProcedure) {
            queryParameters['filterProcedure'] = requestParameters.filterProcedure;
        }

        if (requestParameters.filterModifier) {
            queryParameters['filterModifier'] = requestParameters.filterModifier;
        }

        if (requestParameters.filterServiceCharge) {
            queryParameters['filterServiceCharge'] = requestParameters.filterServiceCharge;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:nynf3"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/nynf3`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderNynf3ClaimFromJSON));
    }

    /**
     * Gets a list of NY NF3 claims
     * Get a list of NY NF3 claims
     */
    async listProviderNynf3Claims(requestParameters: ListProviderNynf3ClaimsRequest): Promise<Array<ProviderNynf3Claim>> {
        const response = await this.listProviderNynf3ClaimsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of nynf3 claim templates
     * Get a list of nynf3 claim templates
     */
    async listSupportNynf3ClaimTemplatesRaw(requestParameters: ListSupportNynf3ClaimTemplatesRequest): Promise<runtime.ApiResponse<Array<SupportNynf3ClaimTemplate>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterStarred !== undefined) {
            queryParameters['filterStarred'] = requestParameters.filterStarred;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterTag) {
            queryParameters['filterTag'] = requestParameters.filterTag;
        }

        if (requestParameters.filterName) {
            queryParameters['filterName'] = requestParameters.filterName;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:nynf3", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/nynf3/template`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportNynf3ClaimTemplateFromJSON));
    }

    /**
     * Gets a list of nynf3 claim templates
     * Get a list of nynf3 claim templates
     */
    async listSupportNynf3ClaimTemplates(requestParameters: ListSupportNynf3ClaimTemplatesRequest): Promise<Array<SupportNynf3ClaimTemplate>> {
        const response = await this.listSupportNynf3ClaimTemplatesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of NY NF3 claims
     * Get a list of NY NF3 claims
     */
    async listSupportNynf3ClaimsRaw(requestParameters: ListSupportNynf3ClaimsRequest): Promise<runtime.ApiResponse<Array<SupportNynf3Claim>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterStarred !== undefined) {
            queryParameters['filterStarred'] = requestParameters.filterStarred;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterTag) {
            queryParameters['filterTag'] = requestParameters.filterTag;
        }

        if (requestParameters.filterPayerId) {
            queryParameters['filterPayerId'] = requestParameters.filterPayerId;
        }

        if (requestParameters.filterSubscriberId) {
            queryParameters['filterSubscriberId'] = requestParameters.filterSubscriberId;
        }

        if (requestParameters.filterPatientId) {
            queryParameters['filterPatientId'] = requestParameters.filterPatientId;
        }

        if (requestParameters.filterFacilityId) {
            queryParameters['filterFacilityId'] = requestParameters.filterFacilityId;
        }

        if (requestParameters.filterProviderId) {
            queryParameters['filterProviderId'] = requestParameters.filterProviderId;
        }

        if (requestParameters.filterSellerId) {
            queryParameters['filterSellerId'] = requestParameters.filterSellerId;
        }

        if (requestParameters.filterPaymentId) {
            queryParameters['filterPaymentId'] = requestParameters.filterPaymentId;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterFirst) {
            queryParameters['filterFirst'] = requestParameters.filterFirst;
        }

        if (requestParameters.filterLast) {
            queryParameters['filterLast'] = requestParameters.filterLast;
        }

        if (requestParameters.filterFirstLast) {
            queryParameters['filterFirstLast'] = requestParameters.filterFirstLast;
        }

        if (requestParameters.filterDiagnosis) {
            queryParameters['filterDiagnosis'] = requestParameters.filterDiagnosis;
        }

        if (requestParameters.filterPriorAuthorizationNumber) {
            queryParameters['filterPriorAuthorizationNumber'] = requestParameters.filterPriorAuthorizationNumber;
        }

        if (requestParameters.filterCharge) {
            queryParameters['filterCharge'] = requestParameters.filterCharge;
        }

        if (requestParameters.filterFromDos) {
            queryParameters['filterFromDos'] = requestParameters.filterFromDos;
        }

        if (requestParameters.filterThroughDos) {
            queryParameters['filterThroughDos'] = requestParameters.filterThroughDos;
        }

        if (requestParameters.filterProcedure) {
            queryParameters['filterProcedure'] = requestParameters.filterProcedure;
        }

        if (requestParameters.filterModifier) {
            queryParameters['filterModifier'] = requestParameters.filterModifier;
        }

        if (requestParameters.filterServiceCharge) {
            queryParameters['filterServiceCharge'] = requestParameters.filterServiceCharge;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:nynf3", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/nynf3`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportNynf3ClaimFromJSON));
    }

    /**
     * Gets a list of NY NF3 claims
     * Get a list of NY NF3 claims
     */
    async listSupportNynf3Claims(requestParameters: ListSupportNynf3ClaimsRequest): Promise<Array<SupportNynf3Claim>> {
        const response = await this.listSupportNynf3ClaimsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a nynf3 claim template
     * Update a nynf3 claim template
     */
    async updateSupportNynf3ClaimTemplateRaw(requestParameters: UpdateSupportNynf3ClaimTemplateRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateSupportNynf3ClaimTemplate.');
        }

        if (requestParameters['supportUpdateNynf3ClaimTemplatePayload'] === null || requestParameters['supportUpdateNynf3ClaimTemplatePayload'] === undefined) {
            throw new runtime.RequiredError('supportUpdateNynf3ClaimTemplatePayload','Required parameter requestParameters.supportUpdateNynf3ClaimTemplatePayload was null or undefined when calling updateSupportNynf3ClaimTemplate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:nynf3", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/nynf3/template/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdateNynf3ClaimTemplatePayloadToJSON(requestParameters['supportUpdateNynf3ClaimTemplatePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update a nynf3 claim template
     * Update a nynf3 claim template
     */
    async updateSupportNynf3ClaimTemplate(requestParameters: UpdateSupportNynf3ClaimTemplateRequest): Promise<ObjectNoResponse> {
        const response = await this.updateSupportNynf3ClaimTemplateRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a NY NF3 claim
     * Update a NY NF3 claim
     */
    async updateSupportNynf3lClaimRaw(requestParameters: UpdateSupportNynf3lClaimRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateSupportNynf3lClaim.');
        }

        if (requestParameters['supportUpdateNynf3ClaimPayload'] === null || requestParameters['supportUpdateNynf3ClaimPayload'] === undefined) {
            throw new runtime.RequiredError('supportUpdateNynf3ClaimPayload','Required parameter requestParameters.supportUpdateNynf3ClaimPayload was null or undefined when calling updateSupportNynf3lClaim.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:nynf3", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/nynf3/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdateNynf3ClaimPayloadToJSON(requestParameters['supportUpdateNynf3ClaimPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update a NY NF3 claim
     * Update a NY NF3 claim
     */
    async updateSupportNynf3lClaim(requestParameters: UpdateSupportNynf3lClaimRequest): Promise<ObjectNoResponse> {
        const response = await this.updateSupportNynf3lClaimRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderNynf3ClaimsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportNynf3ClaimTemplatesOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportNynf3ClaimsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
